export const getDevices = mediaDevices => mediaDevices.reduce((acc, mediaDevice) => {
	if (mediaDevice.kind === 'videoinput') {
		acc.push(mediaDevice.deviceId);
	}

	return acc;
}, []);
